import { render } from 'preact';
import { App } from './app';
import { startInstallWatch } from './state/install';
import { watchForUpdate } from './state/update';
import { nativeBundleReadyAfterRender } from './state/native-update';
import { isNativeShell } from './config/origin';
import './styles.css';

// Before the first render, not from an effect inside a component that waits on a
// network fetch. See state/install.ts: the event fires once and used to be missed.
startInstallWatch();

const root = document.getElementById('app');
if (root) {
  render(<App />, root);
  nativeBundleReadyAfterRender()();
}
// Native assets are selected and authenticated by the APK. A service worker could
// otherwise serve a stale page over a newly selected bundle at the same local origin.
if (isNativeShell() && 'serviceWorker' in navigator) {
  void navigator.serviceWorker.getRegistrations().then(registrations => {
    for (const registration of registrations) void registration.unregister();
  }).catch(() => {});
}

// The service worker is what makes an installed app open offline. Registered late so it
// never competes with the first paint or the manifest fetch.
if (!isNativeShell() && 'serviceWorker' in navigator && import.meta.env.PROD) {
  // Before registering, not after: a worker that is already waiting can claim the page
  // the instant registration resolves, and the listener has to exist by then.
  watchForUpdate();
  addEventListener('load', () => {
    void navigator.serviceWorker.register('/sw.js', { scope: '/' });
  });
}
